import { createAction } from '@reduxjs/toolkit'

export const UPDATE_ANONYMOUS_ID = 'segment/anonymousId/update'

export const updateAnonymousId = createAction(UPDATE_ANONYMOUS_ID)
